import Inside from "./Inside";
import Urls from "../../api/endpoints";
import React, { useState, useEffect } from "react";
import { NotLogin, Loading } from "../../shared/index";
import { ErrorHandling, ErrorHandlingAPI } from "../../functions/index";
import { useLocation } from "react-router-dom";
import { LocationCity } from "@material-ui/icons";
import { getSearchedUserById } from "../../api/requestAxios/userInfo";

function UserInfo(props) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  let location = useLocation();

  const [userId, setUserId] = useState("");
  const [token, setToken] = useState("");
  const [login, setLogin] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);

  useEffect(() => {
    if (isRefresh || (props.userId && props.token)) {
      fetch(Urls.getSearchedUserById(props.userId), {
        method: "Get",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          setIsRefresh(false);
          if (data.Success) {
            setCustomer(data);
          } else {
            ErrorHandlingAPI(data);
          }
        })
        .catch((error) => {
          ErrorHandling(error, "search error", setLoading);
        });
    }
  }, [props.userId, props.token, isRefresh, location]);

  return (
    <main>
      {!props.login ? (
        <NotLogin></NotLogin>
      ) : loading ? (
        <Loading></Loading>
      ) : (
        <Inside
          customer={customer}
          isRefresh={setIsRefresh}
          token={props.token}
          userId={props.userId}
        ></Inside>
      )}
    </main>
  );
}
export default UserInfo;
